<template>
  <component :is="tag_type" class="guide_title">
    <span class="guide_title-text-inblock">鈨組</span>
    <span class="guide_title-text-inblock">二次創作</span>
    <span class="guide_title-text-inblock">ガイドライン</span>
  </component>
</template>

<script>
export default {
  props: {
    tag_type: {
      type: String,
      default: 'div'
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/stylesheets/variables';
.guide_title {
  display: inline-block;
  border: 6px solid;
  padding: 4px 0;
  font-size: 36px;
  width: 100%;
  text-align: center;
  box-sizing: border-box;

  &-text-inblock {
    display: inline-block;
  }
}

@media screen and (max-width: 980px) {
  .guide_title {
    font-size: 28px;
  }
}
</style>
